export default defineNuxtRouteMiddleware((from, to) => {
    console.log("enter auth middleware");
    const user = useSupabaseUser()

    if (!user.value) {
        return navigateTo('/auth')
    }
})